<template>
  <div>
    <StepHeader
      :title="title"
    />

    <StepContent
      width="lg"
    >
      <AppInput
        v-for="(field, index) in fields"
        :key="index"
        :label="field.label"
        :value="field.value"
        :error="field.error"
        :name="field.name"
        v-data-layer
        :data-layer="`${field.name}_field`"
        @input="handleInput(field.name, $event)"
      />
    </StepContent>

    <StepFooter>
      <AppButtonContinue
        v-data-layer
        :data-layer="datalayerContinue"
        @click="handleContinue()"
      >
        Continue
      </AppButtonContinue>

      <StepTooltip>
        We won’t come visit but we need these details to confirm your employment status so you can get the best rates possible.
      </StepTooltip>
    </StepFooter>
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import AppInput from '../inputs/AppInput'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import StepHeader from '@/components/common/step/StepHeader'
import StepTooltip from '@/components/common/step/StepTooltip'
import validation from '@/mixins/validation'

export default {
  // Name
  name: 'employment-job-details',

  // Components
  components: {
    AppButtonContinue,
    AppInput,
    StepContent,
    StepFooter,
    StepHeader,
    StepTooltip
  },

  // Mixins
  mixins: [validation],

  // Data
  data () {
    return {
      datalayerStepName: 'emp_job_details',
      submitted: false,
      errors: {
        isRequired: 'This field is required.'
      }
    }
  },

  // Computed
  computed: {
    fields () {
      return [{
        label: 'Company Name',
        name: 'company_name',
        value: this.companyName,
        error: this.companyNameError
      }, {
        label: 'Job Title',
        name: 'job_title',
        value: this.jobTitle,
        error: this.jobTitleError
      }]
    },

    companyName () {
      return this.$store.state.application.company_name
    },

    companyNameError () {
      if (!this.submitted) return
      if (!this.companyName) return this.errors.isRequired
      if (this.companyName.length > 50) return this.getMaxLengthErrorMessage(50)
    },

    jobTitle () {
      return this.$store.state.application.job_title
    },

    jobTitleError () {
      if (!this.submitted) return
      if (!this.jobTitle) return this.errors.isRequired
      if (this.jobTitle.length > 50) return this.getMaxLengthErrorMessage(50)
    },

    isValid () {
      return !this.companyNameError && !this.jobTitleError
    },

    source_of_income () {
      return this.$store.state.application.source_of_income
    },

    isSelfEmployed () {
      return this.source_of_income === 'Self-Employed'
    },

    datalayerContinue () {
      return `${this.datalayerStepName}_continue`
    },

    title () {
      return this.isSelfEmployed
        ? 'What Do You Do For Work?'
        : 'Where Do You Work?'
    },

    stepIsValid () {
      return !this.companyNameError && !this.jobTitleError
    }
  },

  // Methods
  methods: {
    /**
     * Handle Input
     * Update the store
     */
    handleInput (field, value) {
      this.$store.updateApplication(field, value)
    },

    /**
     * Handle Continue
     * @emits next
     */
    handleContinue () {
      this.submitted = true
      if (this.isValid) this.$emit('next')
    }
  }
}
</script>

<style scoped lang="scss">
</style>
